import Pointer from "poin"
import * as Preact from "preact"
import {nanoid} from "nanoid"
import Objdict from "objdict"
import isString from "@frog/source/utility/isString.js"

import App from "@frog/source/models/App.js"
import Dev from "@frog/source/models/dev/Dev.js"
import Navigation from "@frog/source/engine/navigating/Navigation.js"
import SequenceAnimation from "@frog/source/engine/animating/SequenceAnimation.js"
import Audiomix from "@frog/source/engine/Audiomix.js"
import Stage from "@frog/source/models/Stage.js"
import SkillPreview from "@frog/source/views/SkillPreviewUI.jsx"
import Chapter from "@frog/source/models/Chapter.js"
import unitJobs from "@frog/source/data/unitJobs.js"
import skills from "@frog/source/data/skills.js"
import unitSprites from "@frog/source/data/unitSprites.js"
import elements from "@frog/source/data/elements.js"
import games from "@frog/source/data/games/index.js"
import Zone from "@frog/source/models/Zone.js"

import UnitSprite from "@frog/source/views/components/UnitSprite.jsx"
import UnitHealthBar from "@frog/source/views/components/UnitHealthBar.jsx"
import UnitExperienceBar from "@frog/source/views/components/UnitExperienceBar.jsx"
import DialogueBox from "@frog/source/views/components/DialogueBox.jsx"
import "@frog/source/views/ChapterUI.less"
import pretty from "pretty-ms"

export default class ChapterUI {
    render() {
        if(App.options.disableHUD == true) return
        const stage = this.props.stage
        return (
            <div class="ChapterUI" isInModal={this.props.stage?.dialogue != undefined}>
                <Buttons stage={stage}/>
                <UnitSummary stage={stage}/>

                <EncounterName stage={stage}/>
                <ChapterPrompt stage={stage}/>
                <BossStatus stage={stage}/>
            </div>
        )
        // <ElementalTriangle/>
        // <Inventory stage={stage}/>
        // <Tutorial stage={stage}/>
        // <EncounterDetails stage={stage}/>
        // <EncounterText stage={stage}/>
        // <PrepareModal/>
    }
}

class BossStatus {
    render() {
        return (
            <div class="BossStatuses">
                {Object.values(this.props.stage.units).filter((unit) => {
                    return unit.properties != undefined
                        && unit.properties.includes("boss")
                        && Zone.isInBounds(this.props.stage.encounters[this.props.stage.currentEncounterKey].zone, unit.position)
                }).map((unit) => {
                    return (
                        <div class="BossStatus" isDead={unit.isDead}>
                            <div class="Label">
                                <span class="Title">
                                    {unit.title || unit.name}
                                </span>
                                <span class="Subtitle">
                                    ({unit.subtitle || unit.jobName}{unit.level && " Lv" + unit.level})
                                </span>
                            </div>
                            <div class="HealthBar">
                                <UnitHealthBar unit={unit} omegaunit={App.game.chapter.selection?.hoveredAction?.omegastage?.units[unit.key]}/>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }
}

class ElementalTriangle {
    render() {
        return (
            <div class="ElementalTriangle">
                <div class="Sword"><div class="Icon"/></div>
                <div class="Spear"><div class="Icon"/></div>
                <div class="Axe"><div class="Icon"/></div>
            </div>
        )
    }
}

class ChapterPrompt {
    render() {
        if(this.props.stage.dialogue != undefined
        || this.props.stage.turn.affiliation != this.props.stage.player.affiliation) {
            return (
                <div class="TutorialPrompt" isHidden={true}/>
            )
        }

        const text = this.text
        if(text == undefined) return
        if(isString(text) == true) {
            return (
                <div class="TutorialPrompt" position="topright">
                    <div class="Text">
                        {text}
                    </div>
                </div>
            )
        } else {
            return text
        }
    }
    get text() {
        if(this.props.stage.hud instanceof Function) {
            return this.props.stage.hud(this.props.stage)
        } else {
            return this.props.stage.hud
        }
    }
}

class EncounterName {
    render() {
        const stage = this.props.stage
        if(stage == undefined) return
        if(stage.currentEncounterKey == undefined) return
        if(stage.encounters[stage.currentEncounterKey] == undefined) return
        if(stage.encounters[stage.currentEncounterKey].name == undefined) return

        return (
            <div class="EncounterName">
                {stage.encounters[stage.currentEncounterKey].name}
            </div>
        )
    }
}

class Buttons {
    render() {
        // if(App.game.chapter.phase != "play") return
        if(App.game.chapter.hasUndoEndTurnButtons === false) return
        if(this.props.stage?.flags["hud"] == "hidden") return

        const timeRemaining = Math.max(0, App.game.chapter.stage.player.timeout - App.game.chapter.timer)
        return [
            <div class="EndTurnGlow" isReady={this.isReady}/>,
            <div class="EndTurnButton" onClick={this.onEndTurn} isReady={this.isReady} gameKey={App.game.slug} isUsable={this.isUsable}>
                <div class="Text">
                    End<br/>Turn
                </div>
                <div class="Shortcut">{App.mode == "gamepad" ? "(y)" : "enter"}</div>
                <div class="Charge" style={{"width": Math.min(100, App.game.chapter.selection.charge / App.game.chapter.selection.maxcharge * 100).toFixed(2) + "%"}}/>
                <div class="Handle"/>
            </div>,
            <div class="UndoButton" onClick={this.onUndo} gameKey={App.game.slug} isUsable={this.isUsable}>
                <div class="Text">Undo</div>
                <div class="Shortcut">{App.mode == "gamepad" ? "(bumper)" : "z"}</div>
                <div class="Handle"/>
            </div>
        ]
    }
    get isUsable() {
        return this.props.stage.dialogue == undefined
            && this.props.stage.turn.affiliation == this.props.stage.player.affiliation
    }
    get isReady() {
        return false // debug, disabling for now

        // Has the player won?
        const hasWon = this.props.stage.scripts?.find((condition) => {
            return condition.isWinCondition == true
                && condition.condition instanceof Function == true
                && condition.condition(this.props.stage) == true
        })
        if(hasWon != undefined) return true

        // Have all player units taken actions?
        return Object.values(this.props.stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.isRemoved != true
                && Zone.isInBounds(this.props.stage.encounters[this.props.stage.currentEncounterKey].zone, unit.position)
                && (unit.energy["move"] == true
                || unit.energy["invoke skill"] == true)
                && unit.affiliation == this.props.stage.player.affiliation
        }).length == 0
    }
    get onUndo() {
        return (event) => {
            event.stopPropagation()
            App.game.chapter.actionTrace.push({"type": "undoAction"})
            Dev.recordSavestate("livePlaytest")
            App.game.chapter.undoAction()
        }
    }
    get onEndTurn() {
        return (event) => {
            if(SequenceAnimation.isPerforming != true) {
                event.stopPropagation()
                const chapter = App.game.chapter
                const randomSeed = nanoid()
                chapter.runningDeltastageSubsum = {}
                chapter.endPlayerTurn(chapter.stage, {"seed": randomSeed})
                chapter.actionTrace.push({
                    "type": "endTurn",
                    "seed": randomSeed,
                    "deltastageSum": chapter.runningDeltastageSubsum
                })
            }
        }
    }
}

class UnitSummary {
    render() {
        if(this.props.stage?.dialogue != undefined) return

        const selection = App.game.chapter.selection
        const selectedUnitKey = selection.selectedUnitKey || selection.hoveredUnitKey
        const selectedUnit = this.props.stage.units[selectedUnitKey]

        if(selection.hoveredAction?.type == "invoke skill") {
            const targetUnit = Stage.findUnitByPosition(this.props.stage, selection.hoveredAction.position)
            return (
                <div class="UnitSummary">
                    <UnitDetails unit={selectedUnit} stage={this.props.stage} position={"left"}/>
                    <UnitDetails unit={targetUnit} stage={this.props.stage} position={"right"}/>
                </div>
            )
        }

        return (
            <div class="UnitSummary">
                <UnitDetails unit={selectedUnit} position={selectedUnit?.affiliation == this.props.stage.player.affiliation ? "left" : "right"} stage={this.props.stage}/>
            </div>
        )
    }
}

class UnitDetails {
    render() {
        if(this.props.unit == undefined) return
        if(this.props.unit.type == "zone" || this.props.unit.type == "spot") return

        const unit = this.props.unit
        const omegaunit = App.game.chapter.selection?.hoveredAction?.omegastage?.units[unit.key]

        const element = elements[unit.element]

        const isSelected = this.props.unit.key == App.game.chapter.selection.selectedUnitKey

        const STATE_DESCRIPTION = {
            "defensive": "Status: Defensive",
            "aggroed": "Status: Hostile",
            "passive": "Status: Passive",
            "afraid": "Status: Frightened",
            "unpredictable-but-defensive": "Status: Defensive",
            "unpredictable": "Status: Frazzled",
        }

        return (
            <div class="UnitDetails" key={unit?.key} position={this.props.position} isSelected={isSelected}>
                <div class="Profile">
                    <div class="Summary">
                        <div class="Portrait">
                            <img src={this.portrait}/>
                        </div>
                        <div class="Properties">
                            <div class="Name">
                                <span class="Text">
                                    {unit.title || unit.name}
                                </span>
                            </div>
                            <div class="Class">
                                <span class="Text">
                                    {unit.subtitle || unit.jobName} {unit.level && "Lv" + unit.level} {unit.role == "monster" ? STATE_DESCRIPTION[unit.state] : ""}
                                </span>
                            </div>
                            <UnitHealthBar unit={unit} omegaunit={omegaunit}/>
                        </div>
                    </div>
                    <div class="Stats">
                        <div class="Health">
                            <div class="Value">{unit.health}/{unit.maxhealth}</div>
                            <div class="Label">HP</div>
                        </div>
                    </div>
                </div>
                <div class="Skills" side="bottom-left">
                    {Object.values(unit.items ?? [unit.primaryItem, unit.secondaryItem, unit.tertiaryItem]).map((item, index) => {
                        if(unit.affiliation != this.props.stage.player.affiliation) return
                        if(item == undefined) return

                        const skillKeys = item.skillKeys || [item.skillKey]
                        return skillKeys.map((skillKey) => {
                            const skill = skills.get(skillKey)
                            if(skill == undefined) return
                            if(skill.isHidden instanceof Function) {
                                if (skill.isHidden({"stage": this.props.stage, "performerKey": unit.key}) == true) return
                            } else {
                                if (skill.isHidden == true) return
                            }
                            return (
                                <div class="Skill"
                                    canSelect={App.game.chapter.selection.activeUnit.energy["invoke skill"] != false}
                                    onMouseUp={(event) => event.stopPropagation()}
                                    onMouseDown={(event) => event.stopPropagation()}
                                    onClick={this.onClickItemSkill(item, skillKey)}
                                    onMouseOver={(event) => App.game.chapter.selection.hoveredItem = item}
                                    onMouseOut={(event) => App.game.chapter.selection.hoveredItem = undefined}
                                    isSelected={App.game.chapter.selection.isSelectedItemSkill(item, skillKey)}>
                                    <div class="Label">
                                        <div>{skill.name || skillKey}</div>
                                        <div class="ItemName">{item.name}</div>
                                    </div>
                                    {this.skillPreview(skillKey)}
                                </div>
                            )
                        })
                    })}
                    {Object.values(unit.skillKeys).map((skillKey, index) => {
                        const skill = skills.get(skillKey)
                        if(skill == undefined) return
                        if(skill.isHidden instanceof Function) {
                            if (skill.isHidden({"stage": this.props.stage, "performerKey": unit.key}) == true) return
                        } else {
                            if (skill.isHidden == true) return
                        }
                        if(unit.affiliation != this.props.stage.player.affiliation) return
                        if(App.game?.chapter?.slug == "wrath") return
                        return (
                            <div class="Skill"
                                canSelect={App.game.chapter.selection.activeUnit.energy["invoke skill"] != false}
                                onMouseUp={(event) => event.stopPropagation()}
                                onMouseDown={(event) => event.stopPropagation()}
                                onClick={this.onClickSkill(skillKey)}
                                onMouseOver={(event) => App.game.chapter.selection.hoveredSkillKey = skillKey}
                                onMouseOut={(event) => App.game.chapter.selection.hoveredSkillKey = undefined}
                                isSelected={App.game.chapter.selection.isSelectedSkill(skillKey)}>
                                <div class="Label">
                                    {skill.name || skillKey}
                                </div>
                                <div class="Number">
                                    {index + 1}
                                </div>
                                {this.skillPreview(skillKey)}
                            </div>
                        )
                    })}
                </div>
                <div class="Inventory">
                    {Object.values(unit.inventory?.items || []).map((item) => (
                        <div class="Item" style={{"background-image": item.image && "url(" + item.image + ")"}}/>
                    ))}
                </div>
            </div>
        )
    }
    skillPreview(skillKey) {
        if(App?.game?.demoes != undefined
        && App?.game?.demoes[skillKey] != undefined
        && App?.game?.chapter?.selection?.hoveredSkillKey == skillKey) {
            return <SkillPreview demo={App.game.demoes[skillKey]}/>
        }
    }
    onClickItemSkill(item, skillKey) {
        return (event) => {
            if(App.game.chapter.selection.selectedItem != item
            || App.game.chapter.selection.selectedSkillKey != skillKey) {
                App.game.chapter.selection.selectedItem = item
                App.game.chapter.selection.selectedSkillKey = skillKey

                const skill = skills[skillKey]
                if(skill.role == "equip") {
                    const unit = this.props.unit
                    const action = unit.actionmap[unit.position.x + "x" + unit.position.y]?.find((action) => {
                        return action.item == item
                            && action.skillKey == skillKey
                    })
                    if(action == undefined) return
                    const omegastage = App.game.chapter.performAction(action)

                    this.selectedItem = undefined
                    this.selectedUnitKey = undefined
                    this.selectedSkillKey = undefined
                    this.selectedSubclassIndex = undefined
                    Audiomix.trigger("Selection:Finish")
                }
            } else {
                App.game.chapter.selection.selectedItem = undefined
                App.game.chapter.selection.selectedSkillKey = undefined
            }
        }
    }
    onClickSkill(skillKey) {
        return (event) => {
            if(App.game.chapter.selection.selectedSkillKey != skillKey) {
                App.game.chapter.selection.selectedSkillKey = skillKey
                App.game.chapter.selection.selectedItem = undefined
            } else {
                App.game.chapter.selection.selectedSkillKey = undefined
                App.game.chapter.selection.selectedItem = undefined
            }
        }
    }
    onHoverElement(elementKey) {
        return () => {
            App.game.chapter.selection.hoveredElementKey = elementKey
        }
    }
    onHoverElementOut() {
        return () => {
            App.game.chapter.selection.hoveredElementKey = undefined
        }
    }
    get portrait() {
        const unit = this.props.unit
        if(unit == undefined) return

        let expression = "neutral"
        if(App.game.chapter.selection?.hoveredAction?.type == "invoke skill"
        && skills.get(App.game.chapter.selection?.hoveredAction?.skillKey).role == "damage") {
            if(App.game.chapter.selection.selectedUnitKey == unit.key) {
                expression = "attack"
            } else if(Stage.findUnitByPosition(this.props.stage, App.game.chapter.selection?.hoveredAction.position)?.key == unit.key) {
                expression = "hurt"
            }
        }

        return unitSprites.portraits[unit.portraitKey]
            || unit.portraits && unit.portraits[expression]
            || unit.portraits?.neutral
    }
}
